import { render } from "./PlanetText.vue?vue&type=template&id=3c4d657c&scoped=true"
import script from "./PlanetText.vue?vue&type=script&lang=js"
export * from "./PlanetText.vue?vue&type=script&lang=js"

import "./PlanetText.vue?vue&type=style&index=0&id=3c4d657c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4d657c"]])

export default __exports__